export type DeepPartial<T> = {
	[K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K];
};

export function deepMerge<T>(target: T, patch: DeepPartial<T>): T {
	const t = target as any;
	const p = patch as any;
	for (const key in p) {
		if (!Object.prototype.hasOwnProperty.call(p, key)) continue;
		const pv = p[key];
		if (isPlainObject(pv) && isPlainObject(t[key])) {
			deepMerge(t[key], pv);
		} else {
			t[key] = pv;
		}
	}
	return target;
}

function isPlainObject(v: any): boolean {
	return v !== null && typeof v === 'object' && !Array.isArray(v);
}
